// Utilities
import { defineStore } from 'pinia'
import { useFilterSchemas } from '@/schemas/useFilterSchemas'
import { useGeneralHelpers } from '@/composables/helpers/useGeneralHelpers'

export const useFilterStore = defineStore('filter', {
  state: () => {
    // Get the filter schema using the useFilterSchemas composable
    const filterSchemas = useFilterSchemas()
    const initialFilterSchema = filterSchemas.getFilterManagerSchema()

    return {
      // Initialize filterManager with the obtained schema
      filterManager: initialFilterSchema
    }
  },
  getters: {
    hasFilterApplied() {
      return this.filterManager.filter.values.length > 0
    },

    hasFilterValue() {
      // Define the recursive function
      const confirmHasFilterValue = filter => {
        if (filter.complex) {
          return filter.values.some(confirmHasFilterValue)
        } else {
          return filter.values.length > 0
        }
      }

      // Apply the recursive function to the top-level filter
      return confirmHasFilterValue(this.filterManager.filter)
    },

    requestReadyFilter() {
      return useGeneralHelpers().requestReadyFilter(this.filterManager.filter)
    }
  },
  actions: {
    setFilterManager(updatedFilterManager) {
      this.filterManager = updatedFilterManager
    },
    setFilter(updatedFilterObject) {
      this.filterManager.filter = updatedFilterObject
    },

    clearFilter() {
      // clear filter to intiial state
      this.filterManager = JSON.parse(JSON.stringify(useFilterSchemas().getFilterManagerSchema()))
    }
  }
})
